
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'
import { COLORANTI_BY_ATTACK } from '../data.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default function BenchmarkChart({ attack, scores }){
  const colorantiColor = COLORANTI_BY_ATTACK[attack] || '#16a085'
  const data = {
    labels: ['AES','RSA','Colorantí'],
    datasets: [{
      label: 'Composite Score',
      data: [scores.AES, scores.RSA, scores.Coloranti],
      backgroundColor: ['#f39c12', '#8e44ad', colorantiColor]
    }]
  }
  const options = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true, max: 100 } }
  }
  return <Bar data={data} options={options} />
}
